import { ApiError } from '@classgo/app-kit';

import type { AlbertRefusalKey } from './types';

const REASONS: Record<string, AlbertRefusalKey> = {
  'no-grading': 'albert.refusal.noGrading',
  'quota-exhausted': 'albert.refusal.quotaExhausted',
  'invalid-output': 'albert.refusal.invalidOutput',
};

const FLAGS: Record<string, AlbertRefusalKey> = {
  'personal-data': 'albert.refusal.personalData',
  injection: 'albert.refusal.injection',
};

/**
 * The message key for a refusal Albert or its guard sent back, or `null` when the error is not
 * one of them (a network error, a 500) and the generic description applies. A 403 with
 * `details.reason` is Albert's own refusal (never grades, quota spent, unusable answer); a 400
 * with `details.flagged` is the screening of the teacher's text; a 403 without a reason is the
 * pair the teacher does not hold; a 400 with validation issues (a group of another grade, a
 * bullet too short) is the input.
 *
 * @param {unknown} error -- What the API call threw.
 * @returns {AlbertRefusalKey | null} The message key, or `null` for errors of any other kind.
 */
export const albertRefusal = (error: unknown): AlbertRefusalKey | null => {
  if (!(error instanceof ApiError)) return null;
  const reason = error.details?.['reason'];
  if (typeof reason === 'string' && REASONS[reason]) return REASONS[reason];
  const flagged = error.details?.['flagged'];
  if (typeof flagged === 'string' && FLAGS[flagged]) return FLAGS[flagged];
  if (error.code === 'FORBIDDEN') return 'albert.refusal.outsideScope';
  if (error.code === 'VALIDATION_FAILED') return 'albert.refusal.validation';
  return null;
};
